import React, {useContext} from 'react';
import { Link, LinkProps } from 'react-router-dom';

import { SiteContext } from 'four-nets';

// BlogLink is aware of site and returns server routed
// link for garden, as garden blog is server thru
// separate Wordpress

const BlogLink: React.FC<LinkProps> = (props) => {
    const site = useContext(SiteContext);

    if (site.isGarden && typeof props.to === 'string') {
        const { to, children, ...rest} = props;
        return <a href={to} {...rest}>{children}</a>;
    }

    const { children, ...rest} = props;
    return <Link {...rest}>{children}</Link>;
}

export default BlogLink;
